<template>
    <div class="activity-data">
        <div class="tops df aic jcsb">
            <div class="left">
                <!-- <el-date-picker v-if="cardfolg == 1" :clearable="false" v-model="queryParam.value" type="week"
                    format="yyyy 第 WW 周" placeholder="选择周">
                </el-date-picker> -->
                <!-- <el-date-picker v-if="cardfolg == 1" :clearable="false" v-model="queryParam.value"
                    :format="'yyyy-MM 第' + queryParam.week + '周'" @change="weekChange" value-format="yyyy-M-d"
                    class="inp" size="medium" type="week" placeholder="请选择"></el-date-picker> -->

                <el-date-picker v-if="cardfolg == 1" :clearable="false" v-model="queryParam.value"
                    :format="'yyyy-MM ' + $t('第几周', { num: queryParam.week })" @change="weekChange"
                    value-format="yyyy-M-d" class="inp" size="medium" type="week"></el-date-picker>

                <el-date-picker v-if="cardfolg == 2" v-model="dateText" :format="handleShowdate()" type="month"
                    @change="handlePicker" :clearable="false">
                </el-date-picker>


                <!-- {{ searchObj }} -->

            </div>
            <div class="right">
                <span class="iconfont" :class="cardfolg == 1 ? 'active' : ''" @click="handleFlog(1)">&#xe609;</span>
                <span class="iconfont" :class="cardfolg == 2 ? 'active' : ''" @click="handleFlog(2)">&#xe608;</span>
            </div>
        </div>

        <!--  -->

        <div class="date-box" v-if="cardfolg == 2">

            <div class="date-thend df">

                <span class="tds f1">
                    <el-button type="text" @click="handlefirst()" class="left-btn mr-16"><span
                            class="iconfont">&#xeaa0;</span></el-button>{{ $t('周日') }}</span>
                <span class="tds f1">{{ $t('周一') }}</span>
                <span class="tds f1">{{ $t('周二') }}</span>
                <span class="tds f1">{{ $t('周三') }}</span>
                <span class="tds f1">{{ $t('周四') }}</span>
                <span class="tds f1">{{ $t('周五') }}</span>
                <span class="tds f1">{{ $t('周六') }}<el-button type="text" @click="handlelast()"
                        class="right-btn ml-16"><span class="iconfont">&#xe7e2;</span></el-button>
                </span>

            </div>


            <el-calendar v-model="selectedDate" :first-day-of-week="0" @change="handleDataChange">
                <template slot="dateCell" slot-scope="{ date, data }">

                    <el-popover placement="right-start" width="400" trigger="hover"
                        v-if="getDateContent(data.day) && getDateContent(data.day).length > 0"
                        popper-class="active-popover" :key="data.day">

                        <div>
                            <div class="list-cell" v-for="(item, index) in getDateContent(data.day)" :key="index">

                                <p class="title mic-semblod one-text" @click="handleLink(item)">{{ item.ta_title }}</p>
                                <p class="date">{{ item.ta_start_time }}</p>
                                <p class="address df aic jcsb">
                                    <span>{{ item.ddt_name }}</span>

                                    <el-button type="primary" class="btns" :class="{ 'sign': item.is_signup == 10 }"
                                        :disabled="item.is_signup == 10" @click="handleSignUp(item)">
                                        {{ item.is_signup == 10 ? $t('已报名') : $t('一键报名') }}
                                    </el-button>
                                </p>
                            </div>
                        </div>
                        <div slot="reference">
                            <p class="text-p">
                                {{ data.day.split('-')[2] }}
                            </p>
                            <div style="height: 46px;overflow: hidden;">
                                <div v-for="item in getDateContent(data.day)" :key="item.title" class="list-box">
                                    <div class="list one-text">{{ item.ta_title }}</div>
                                </div>
                            </div>
                        </div>
                    </el-popover>
                    <p class="text-p" v-else>
                        {{ data.day.split('-')[2] }}
                    </p>
                    <!-- <p class="text-p" v-else>
                        {{ data.day.split('-')[2] }}
                    </p> -->
                </template>
            </el-calendar>
        </div>

        <div class="datelist-box f1" v-if="cardfolg == 1">
            <!-- {{ listData }} -->
            <dataList :data="listData == [] ? {} : listData"></dataList>

        </div>
    </div>
</template>

<script>
import dataList from "./datalist.vue";
import { getactivityCalendar, setSignUp } from "@api/active";
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

export default {
    components: {
        dataList
    },
    data() {

        return {

            cardfolg: 2,  //默认选中卡片式


            value: new Date(),

            // 选择周
            queryParam: {
                value: '',
                week: ''
            },

            dateText: '',  // 年月
            selectedDate: new Date(), // 当前选中的日期

            dateList: {},

            searchObj: {
                calendar_type: 10, //10月份  20 周
                ta_year: new Date().getFullYear().toString(),
                ta_month: (new Date().getMonth() + 1).toString().padStart(2, '0'),

            },

            // 列表式的data
            listData: {},


        }
    },
    created() {
        this.getDay();
    },
    mounted() {
        this.getData();
        this.dateText = new Date();
        let Language = localStorage.getItem('currentLanguage');  //获取本地语言
        if (Language && Language != 'zh') {
            locale.use(lang)
        }

    },

    watch: {
        // 监听 message 属性的变化
        selectedDate(newValue, oldValue) {
            this.dateText = newValue;
            const date = new Date(this.dateText); // 创建当前日期的副本

            this.dateText = date;

            this.searchObj['ta_year'] = this.dateText.getFullYear().toString();
            this.searchObj['ta_month'] = (this.dateText.getMonth() + 1).toString().padStart(2, '0');
            this.dateList = {};
            this.getData();
        }
    },
    methods: {
        handleDataChange() {

        },

        handleShowdate() {
            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                return "MMMM yyyy"
            } else {
                return "yyyy 月 MM 日"
            }
        },


        // 上一月
        handlefirst() {

            const date = new Date(this.dateText); // 创建当前日期的副本
            date.setMonth(date.getMonth() - 1); // 设置为上一月

            this.dateText = date;
            this.selectedDate = this.dateText;
            this.searchObj['ta_year'] = this.dateText.getFullYear().toString();
            this.searchObj['ta_month'] = (this.dateText.getMonth() + 1).toString().padStart(2, '0');
            this.dateList = {};
            this.getData();
        },
        // 下一月
        handlelast() {
            const date = new Date(this.dateText); // 创建当前日期的副本
            date.setMonth(date.getMonth() + 1); // 设置为上一月

            this.dateText = date;
            this.selectedDate = this.dateText;
            this.searchObj['ta_year'] = this.dateText.getFullYear().toString();
            this.searchObj['ta_month'] = (this.dateText.getMonth() + 1).toString().padStart(2, '0');
            this.dateList = {};
            this.getData();
        },
        // 跳转活动详情
        handleLink(item) {
            let str = '/cn';
            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = '/' + Language;
            }
            this.$router.push(str + '/activity/info/' + item.ta_id); // 使用编程式导航跳转到 About 页面
        },
        getDay() {
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            let nowDay = year + '-' + month + '-' + day;
            this.queryParam.week = this.getWeekInMonth(new Date(nowDay));
            this.queryParam.value = year + '-' + month + '-' + day;
        },
        async weekChange(val) {

            if (val) {
                this.queryParam.week = this.getWeekInMonth(new Date(val));
            }
            const date = new Date(val);
            let ta_year = date.getFullYear(); // 获取年份
            const ta_month = date.getMonth() + 1;
            this.searchObj.ta_week = this.queryParam.week;

            this.searchObj.ta_month = ta_month;
            this.searchObj.ta_year = ta_year;

            let res = await getactivityCalendar({ ...this.searchObj });
            if (res.status == 200) {
                const newData = {};
                for (const key in res.data.act_list) {
                    // 将日期格式化为 "日"
                    const day = key.split("-")[2]; // 获取日期部分

                    newData[day] = res.data.act_list[key]; // 将原始值赋给新键
                }

                this.listData = newData;

                // this.listData = res.data.act_list;
            }

        },
        // 根据日期判断是月的第几周
        getWeekInMonth(t) {
            // 如果没有传入日期，则使用当前日期
            if (!t) {
                t = new Date(); // 使用当前日期
            }
            const _t = new Date(t); // 创建一个新的日期对象
            const date = _t.getDate(); // 获取给定日期是几号
            _t.setDate(1); // 设置为该月的第一天
            const d = _t.getDay(); // 获取该月第一天是星期几

            // 计算第一周的最后一天
            let firstWeekend = d === 0 ? 7 : 7 - d; // 计算第一周的最后一天

            // 如果给定日期在第一周内
            if (date <= firstWeekend) {
                return 1; // 返回 1，表示在第一周
            } else {
                // 计算周数
                return 1 + Math.ceil((date - firstWeekend - 1) / 7); // 计算周数
            }
        },
        // getWeekInMonth(t) {
        //     console.log(t)
        //     if (t == undefined || t == '' || t == null) {
        //         t = new Date();
        //     } else {
        //         var _t = new Date();
        //         _t.setYear(t.getFullYear());
        //         _t.setMonth(t.getMonth());
        //         _t.setDate(t.getDate());

        //         var date = _t.getDate(); //给定的日期是几号

        //         _t.setDate(1);
        //         var d = _t.getDay(); //1. 得到当前的1号是星期几。

        //         var fisrtWeekend = d;

        //         if (d == 0) {
        //             fisrtWeekend = 1;
        //             //1号就是星期天
        //         } else {
        //             fisrtWeekend = 7 - d + 1; //第一周的周未是几号
        //         }
        //         console.log(fisrtWeekend, "xinqji")

        //         if (date <= fisrtWeekend) {
        //             return 1;
        //         } else {

        //             return 1 + Math.ceil((date - fisrtWeekend) / 7);
        //         }
        //     }
        // },
        // 日期修改
        handlePicker() {
            this.selectedDate = this.dateText;

            this.searchObj['ta_year'] = this.dateText.getFullYear().toString();
            this.searchObj['ta_month'] = (this.dateText.getMonth() + 1).toString().padStart(2, '0');
            this.dateList = {};

            this.getData();
        },
        // 意见报名
        async handleSignUp(item) {

            let res = await setSignUp({ ta_id: item.ta_id });
            if (res.status == 200) {
                this.$message({
                    message: res.msg,
                    type: 'success'
                });
            }
        },
        // 获取数据
        async getData() {
            let res = await getactivityCalendar({ ...this.searchObj });

            this.dateList = res.data.act_list;


        },
        getDateContent(day) {
            // 查找与给定日期匹配的内容
            let day_l = day.split("-")[2].replace(/^0/, '')
            let day_m = day.split("-")[1].replace(/^0/, '')
            let found = [];

            const date = new Date(this.dateText);
            const month = date.getMonth() + 1; // 加 1 使其从 1 开始
            // let day_month = month.replace(/^0/, '');

            if (day_m == month) {
                found = this.dateList[day_l];
            }
            return found;

        },
        getLastMonthDate() {
            const date = new Date();
            date.setMonth(date.getMonth() - 1); // 将月份减去 1
            return date; // 返回上一个月的日期
        },

        async handleFlog(index) {
            // this.searchObj.calendar_type
            switch (index) {
                case 1:

                    this.searchObj.ta_week = this.queryParam.week;
                    this.searchObj.ta_month = this.queryParam.value.split("-")[1];
                    this.searchObj.calendar_type = 20;
                    let res = await getactivityCalendar({ ...this.searchObj });
                    if (res.status == 200) {
                        const newData = {};
                        for (const key in res.data.act_list) {
                            // 将日期格式化为 "日"
                            const day = key.split("-")[2]; // 获取日期部分

                            newData[day] = res.data.act_list[key]; // 将原始值赋给新键
                        }

                        this.listData = newData;
                    }
                    break;
                case 2:
                    this.searchObj.calendar_type = 10;
                    break;
                default:
                    break;
            }
            this.cardfolg = index;
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep() {
    .el-date-picker table tr {
        display: flex;
    }

    .left .el-input__inner {
        font-family: "harmonyos";
    }

    .left .el-input__inner:hover {
        color: #B7251E;
    }
}

.date-thend {
    position: relative;

    span {
        height: 40px;
        text-align: center;
        color: rgb(25, 25, 25);
        font-family: "harmonyos";
        font-size: 14px;
        font-weight: 400;
        line-height: 40px;
    }

    // .left-btn {
    //     .left-btn {

    //         text-align: center;
    //         color: rgb(25, 25, 25);
    //         font-family: "harmonyos";
    //         font-size: 14px;
    //         font-weight: 400;
    //         line-height: 40px;
    //     }
    // }
    .left-btn,
    .right-btn {
        padding: 0;
        height: 40px;

        .iconfont {
            color: #191919;
            font-size: 10px;
        }
    }

    // button {
    //     position: absolute;
    // }
}

.tops {
    padding: 7px 16px 4px 16px;

    .right {
        width: 64px;
        height: 32px;
        border-radius: 6px;
        /* fill/color-fill-2 */
        background: rgb(243, 243, 243);
        padding: 2px;

        span {
            display: inline-block;
            width: 28px;
            height: 28px;
            text-align: center;
            line-height: 28px;
            color: #939393;
            cursor: pointer;
        }

        span.active {
            color: #B7251E;
            border-radius: 4px;
            box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
            /* bg/color-bg-1 */
            background: rgb(255, 255, 255);
        }

        span:nth-child(2) {
            margin-left: 4px
        }
    }

    ::v-deep() {


        .el-input__prefix {
            display: none;
        }

        .el-input--prefix .el-input__inner {
            padding: 0;
            height: 24px;
            line-height: 24px;
            border: none;
            max-width: 138px;
        }
    }
}

:deep(.el-calendar-table td.is-selected) {
    background-color: #FFF3F2;
}

.list-cell {
    width: 100%;
    margin-top: 16px;

    &:first-child {
        margin-top: 0;
    }

    .title {
        color: rgb(25, 25, 25);
        font-size: 18px;
        font-weight: 400;
        line-height: 24px;
        position: relative;
        cursor: pointer;

        &:hover {
            color: #B7251E;
        }

        &::after {
            content: "";
            display: inline-block;
            width: 3px;
            height: 20px;
            border-radius: 40px;
            background: rgb(183, 37, 30);
            position: absolute;
            left: -13px;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .date {
        color: rgb(25, 25, 25);
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        margin-top: 12px;
    }

    .address {

        width: 100%;
        color: rgb(25, 25, 25);
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        margin-top: 8px;
    }

    .btns {
        min-width: 96px;
        height: 32px;
        box-sizing: border-box;
        border: 1px solid rgb(183, 37, 30);
        background-color: #ffffff;
        border-radius: 20px;
        padding: 0 16px;
        font-size: 14px;
        color: #B7251E;

        &.sign {
            background-color: rgba(241, 99, 92, 0.2);
            border: none;
            color: #B7251E;
        }

        &:hover {
            border: 1px solid rgb(221, 115, 109);
            color: #DD736D;
        }
    }
}

.left {
    ::v-deep() {
        .el-input__suffix {
            position: relative;
            top: -1px;
            right: 24px;
        }

        .el-input__suffix::after {
            content: "\e613";
            font-family: "iconfont";
            font-size: 8px;
            color: #595959;
        }
    }
}

::v-deep() {
    .date-box thead {
        display: none;
    }
}

.date-box {

    .next,
    .prev {
        .text-p {
            color: #AEAEAE;
        }
    }

    .text-p {
        font-size: 14px;
        color: #191919;
    }

    .list-box {
        &:first-child {
            .list {
                margin-top: 0;
            }

        }

        .list {
            color: rgb(25, 25, 25);
            font-size: 12px;
            font-weight: 400;
            line-height: 20px;
            position: relative;
            padding-left: 6px;
            margin-top: 2px;



            &::after {
                content: "";
                display: inline-block;
                width: 2px;
                height: 12px;
                border-radius: 40px;
                background: rgb(183, 37, 30);
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
}



::v-deep() {
    .el-calendar__body {
        padding: 0px;
    }

    .el-calendar__header {
        display: none;
    }

    .el-calendar-table .el-calendar-day {
        padding: 4px 8px;
        height: 71.66px;

        &:hover {
            background: rgb(255, 243, 242);
        }
    }

    .el-calendar-table thead th {
        padding: 9px 0;
    }

    .el-calendar-table td {
        border-bottom: 1px solid rgb(233, 233, 233);
        border-right: 1px solid rgb(233, 233, 233);
    }


}
</style>

<style lang="scss">
.active-popover {
    padding: 18px 20px 18px 30px;
    border-radius: 8px;
    box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.16);
    background: rgb(255, 255, 255);
}

.active-popover .popper__arrow {
    display: none;
}

::v-deep() {
    .el-popper[x-placement^=right] .popper__arrow {
        display: none;
    }

}
</style>